module.exports = __webpack_public_path__ + "img/titanTitle2.9fb88acf.png";